import { Student } from 'src/app/model/student/student.model';
import { StudentIdentifierTypes } from './student-identifier-types.model';
import { StudentIdentifierOrganizations } from './student-identifier-organizations.model';
export class StudentIdentifiers {
    ID: number;
    STUDENTS_ID: number;
    STUDENT_IDENTIFIER_TYPES_ID: number;
    IDENTIFIER_VALUE: string;
    CREATED_BY: string;
    CREATED_DATE: Date;
    MODIFIED_BY: string;
    MODIFIED_DATE: Date;
    MERGED_RECORD: number;
    STUDENT_IDENTIFIER_ORGANIZATIONS: StudentIdentifierOrganizations[];
    STUDENT_IDENTIFIERS_H: StudentIdentifiers;
    STUDENT_IDENTIFIER_TYPES: StudentIdentifierTypes;
    STUDENT: Student;
}
